import React, { Component } from "react";
import SmartInput from "./smart-input.js";
import SmartSelect from "./smart-select.js";
import SmartCheckbox from "./smart-checkbox.js";
import SmartErrorConsole from "./smart-error-console.js";
import { validateEmailWrapper, validatePasswordWrapper, validateRequiredField } from "../../../services/utils/form.js";

import "./smart-form.css";

class SmartForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: [],
            input_validations: {},
            submitting: false
        };
    }

    componentDidMount() {
        this.flushData();
        this.prepareInputValidations();
    }

    prepareInputValidationFunction(validationFunction, currentInput) {
        if (currentInput.required) {
            return validationFunction;
        }
        else {
            return function (value) {
                if (value !== "") {
                    return validationFunction(value);
                }
                else {
                    return {
                        valid: true
                    }
                }
            }
        }
    }

    prepareInputValidations() {
        let { config } = this.props;
        let inputs = config.inputs;
        let inputValidations = {};

        for (let index in inputs) {
            let currentInput = inputs[index];
            let inputName = currentInput.name;

            if (currentInput.validation) {
                inputValidations[inputName] = currentInput.validation;
            }
            else if (currentInput.type === "email") {
                inputValidations[inputName] = this.prepareInputValidationFunction(validateEmailWrapper, currentInput);

            }
            else if (currentInput.type === "password") {
                inputValidations[inputName] = this.prepareInputValidationFunction(validatePasswordWrapper, currentInput);

            }
            else if (currentInput.required) {
                inputValidations[inputName] = this.prepareInputValidationFunction(function (value) {
                    return validateRequiredField(currentInput.label, value);
                }, currentInput);
            }
        }
        this.setState({ input_validations: inputValidations });
    }

    flushData() {
        let { config, set } = this.props;

        if (set) {
            return;
        }

        let inputs = config.inputs;
        let data = {};

        for (let index in inputs) {
            let currentInput = inputs[index];

            if (currentInput.type === "text" || currentInput.type === "password" || currentInput.type === "email") {
                data[currentInput.name] = "";
            }
            else if (currentInput.type === "select") {
                if (currentInput.multiple) {
                    data[currentInput.name] = [];
                }
                else {
                    data[currentInput.name] = "";
                }
            }
        }
        this.setState({ data: data });
    }

    update(inputName, inputValue) {
        let { data } = this.state;
        let newData = { ...data };
        newData[inputName] = inputValue;
        this.setState({ data: newData });
    }

    isFieldActive(fieldConfig) {
        let { data } = this.state;

        if (!fieldConfig.parent_field) {
            //No parent field, active!
            return true;
        }
        //We have a parent field
        let parentFieldValue = data[fieldConfig.parent_field];
        let activeValues = fieldConfig.active_values;

        for (let i = 0; i < activeValues.length; i++) {
            if (activeValues[i] === parseInt(parentFieldValue, 10)) {
                return true;
            }
        }
        return false;
    }

    generateInputs() {
        let { config, clear } = this.props;
        let inputs = config.inputs;
        let shouldClear = false;

        if (clear) {
            shouldClear = true;
        }

        let { set } = this.props;

        let data;
        if (set) {
            set.password = "";
            this.setState({
                data: set
            });
            data = set;
        }
        else {
            data = this.state.data;
        }

        return inputs.map((inputConfig) => {
            let value = data[inputConfig.name];

            if (!this.isFieldActive(inputConfig)) {
                return "";
            }

            if (inputConfig.type === "select") {
                return <SmartSelect config={inputConfig} on_change={this.update.bind(this)} clear={shouldClear} value={value} />
            }
            else if (inputConfig.type === "checkbox") {
                return <SmartCheckbox config={inputConfig} on_change={this.update.bind(this)} clear={shouldClear} value={value} />
            }
            else {
                return <SmartInput config={inputConfig} on_change={this.update.bind(this)} clear={shouldClear} value={value} />
            }
        });
    }

    validate() {
        let { data, input_validations } = this.state;
        let name;
        let errors = [];
        let isValid = true;

        for (name in input_validations) {
            let currentValue = data[name];
            let validationFunc = input_validations[name];

            let validationResponse = validationFunc(currentValue);

            if (!validationResponse.valid) {
                isValid = false;
                errors.push(validationResponse.message);
            }
        }
        this.setState({ errors: errors });
        return isValid;
    }

    addError(errorMessage) {
        let { errors } = this.state;
        let newErrors = errors;
        newErrors.push(errorMessage);
        this.setState({ errors: newErrors });
    }

    async submit() {
        let { on_submit } = this.props;
        let { data } = this.state;

        let isValid = this.validate();

        if (!isValid) {
            return;
        }

        let submitFunction = on_submit;
        this.setState({ submitting: true });
        await submitFunction(data);
        this.setState({ submitting: false });
    }

    render(e) {
        let { config, submission_errors } = this.props;
        let { errors, submitting } = this.state;

        errors = errors.concat(submission_errors);

        let submitConfig = config.submit;

        let submitText = "Submit";
        let submitClass = "smart_form_submit";

        if (submitConfig) {
            if (submitConfig.text) {
                submitText = submitConfig.text;
            }

            if (submitConfig.centered) {
                submitClass += " centered";
            }
        }

        return (
            <div className='smart_form_container'>
                <form className='smart_form'>
                    <SmartErrorConsole errors={errors} />
                    {this.generateInputs()}
                    {!submitting && <div className={submitClass} onClick={this.submit.bind(this)}>{submitText}</div>}
                    {submitting && <div className='smart_form_submit_loader'>Working... <i className='smart_form_submit_loader_icon fa fa-spin fa-spinner'></i></div>}
                </form>
            </div>
        );
    }
}

export default SmartForm;


// WEBPACK FOOTER //
// ./src/components/components/smart-form/smart-form.js